import { makeObservable, observable, action } from "mobx";

import {HttpResponse, userController} from "../api";
import { UserResponse, UsersRequest, UserWallet } from "../models";
import {DEFAULT_RESPONSE_LIST} from "../constants";
import { RootStore } from ".";

export class UserStore {
  private rootStore?: RootStore;

  public managerId: null | number = null;

  public userList = new HttpResponse<UserResponse>(DEFAULT_RESPONSE_LIST);

  public wallet = new HttpResponse<UserWallet>({
    balance: 0,
    limit: 0,
    managerId: 0,
  });

  constructor(rootStore?: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      userList: observable,
      managerId: observable,
      wallet: observable,
      setUserList: action.bound,
      setWallet: action.bound,
    });
  }

  public setUserList(value: HttpResponse<UserResponse>): void {
    this.userList = value;
  }

  public setWallet(value: HttpResponse<UserWallet>): void {
    this.wallet = value;
  }

  public updateWallet(value: UserWallet): void {
    const updatedWallet = this.wallet.fetched(value);
    this.setWallet(updatedWallet);
  }

  public async getWallet(): Promise<void> {
    this.setWallet(this.wallet.fetching());
    const data = await userController.getWallet();
    this.managerId = data.managerId;
    this.setWallet(this.wallet.fetched(data));
  }

  public async getUserList(params: UsersRequest): Promise<void> {
    this.setUserList(this.userList.fetching());
    const data = await userController.getUsers(params);
    this.setUserList(this.userList.fetched(data));
  }

  public resetUserList(): void {
    this.setUserList(this.userList.fetched(DEFAULT_RESPONSE_LIST));
  }
}
